<template>
    <v-container class="text-xs-center"> 
        <v-layout row wrap justify-center>
            <v-flex xs12 md10>
                <v-btn class="home-button" block dark @click.native="$router.push({name: 'customers'})">
                    <div>
                        <i aria-hidden="true" class="v-icon material-icons theme--light">group</i> 
                        Clienti
                    </div>
                </v-btn>
                <v-btn class="home-button" block dark @click.native="$router.push({name: 'services'})">
                    <div>
                        <i aria-hidden="true" class="v-icon material-icons theme--light">room_service</i> 
                        Servizi
                    </div>
                </v-btn>
                <v-btn class="home-button" block dark @click.native="$router.push({name: 'appointments'})">
                    <div>
                        <i aria-hidden="true" class="v-icon material-icons theme--light">event</i> 
                        Appuntamenti
                    </div>
                </v-btn>
                <v-btn class="home-button" block dark @click.native="logout()">
                    <div>
                        <i aria-hidden="true" class="v-icon material-icons theme--light">logout</i> 
                        Logout
                    </div>
                </v-btn>
                <v-btn class="home-button" block dark @click.native="downloadWeb()">
                    <div>
                        <i aria-hidden="true" class="v-icon material-icons theme--light">picture_as_pdf</i> 
                        Registro pensione (pdf)
                    </div>
                </v-btn>
                <v-btn class="home-button" block dark  @click.native="downloadWebAsilo()">
                    <div>
                        <i aria-hidden="true" class="v-icon material-icons theme--light">picture_as_pdf</i> 
                        Registro asilo (pdf)
                    </div>
                </v-btn>
                <v-btn class="home-button" block dark @click.native="$router.push({name: 'Pensione'})">
                    <div>
                        <i aria-hidden="true" class="v-icon material-icons theme--light">description</i> 
                        Registro pensione
                    </div>
                </v-btn>
                <v-btn class="home-button" block dark  @click.native="$router.push({name: 'Asilo'})">
                    <div>
                        <i aria-hidden="true" class="v-icon material-icons theme--light">description</i> 
                        Registro asilo
                    </div>
                </v-btn><br><br>
                <v-btn class="home-button" block dark  @click.native="$router.push({name: 'Allevamento'})">
                    <div>
                        <i aria-hidden="true" class="v-icon material-icons theme--light">pets</i> 
                        Allevamento
                    </div>
                </v-btn>
                <v-btn class="home-button" block dark  @click.native="downloadWebAllevamento()">
                    <div>
                        <i aria-hidden="true" class="v-icon material-icons theme--light">picture_as_pdf</i> 
                        Registro allevamento (pdf)
                    </div>
                </v-btn>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>

import download from "downloadjs";
const axios = require('axios').default;
export default {
    name: 'Home',
    data: function(){
        return{
        };
    },
    mounted: function(){
        let vm = this;
        vm.getCurrentSession();
    },
    methods:{
        getCurrentSession(){
            let vm = this;
            axios({
                method: "GET",
                url: vm.$API_BASE_URL + "getSession.php",
                headers: {
                    'Authentication-Token': window.localStorage.getItem("sogno_at")
                }
            })
            .then(function (response) {
                if (response.status != 200) {
                    vm.$router.push({name: 'login'});
                } 
            })
            .catch(function (error) {
                console.log("Nessuna sessione valida attiva");
                vm.$router.push({name: 'login'});
            });
        },
        logout(){
            let vm = this;
            axios({
                method: "POST",
                url: vm.$API_BASE_URL + "user/logout.php",
                headers: {
                    'Authentication-Token': window.localStorage.getItem("sogno_at")
                }
            })
            .then(function () {
                vm.$router.push({name: 'login'});
            })
            .catch(function (error) {
                alert("Errore durante il logout");
            });
        },
        downloadWeb() {
            let vm = this;
            axios
                .get(
                    vm.$API_BASE_URL + "downloadReport.php",
                {
                    headers: {
                        'Authentication-Token': window.localStorage.getItem("sogno_at")
                    },
                    responseType: "blob",
                }
            )
            .then(async response => {
            const content = response.headers["content-type"];
            vm.savingLoading = false;
            download(
                response.data,
                "Registro pensione",
                content
            );
            })
            .catch(error => {
                alert(JSON.stringify(error))
            });
        },
        downloadWebAsilo() {
            let vm = this;
            axios
                .get(
                    vm.$API_BASE_URL + "downloadReportAsilo.php",
                {
                    headers: {
                        'Authentication-Token': window.localStorage.getItem("sogno_at")
                    },
                    responseType: "blob",
                }
            )
            .then(async response => {
            const content = response.headers["content-type"];
            vm.savingLoading = false;
            download(
                response.data,
                "Registro asilo",
                content
            );
            })
            .catch(error => {
                alert(JSON.stringify(error))
            });
        },
        downloadWebAllevamento() {
            let vm = this;
            axios
                .get(
                    vm.$API_BASE_URL + "downloadReportAllevamento.php",
                {
                    headers: {
                        'Authentication-Token': window.localStorage.getItem("sogno_at")
                    },
                    responseType: "blob",
                }
            )
            .then(async response => {
            const content = response.headers["content-type"];
            vm.savingLoading = false;
            download(
                response.data,
                "Registro allevamento",
                content
            );
            })
            .catch(error => {
                alert(JSON.stringify(error))
            });
        },
    }
}
</script>

<style>
    .home-button{
        display: inline-block;
        height: 75px;
        width: calc(49% - 10px);
        border-radius: 16px;
        vertical-align: middle;
        margin:2px 0 2px 0;
        margin-right:1%;
        padding: 0 5px;
        cursor: pointer;
        background: #209ecc!important;
        font-size:22px;
        font-weight: 400;
        text-align:left;
    }
    .home-button>div{
        display: block;
        width:90%;
    }
</style>
